import * as XLSX from 'xlsx';
import { ConvertOIDValueToString } from './configConverter';

/**
 * Bölge raporunu Excel formatında indirir
 * Hem ana bölge hem de alt bölge verilerini tek sayfada gösterir
 *
 * @param {Array} data - Bölge satış raporu verileri
 * @param {Array} regions - Tüm bölgeler listesi
 */
export const exportRegionReport = (data, regions) => {
  try {
    // Ana bölge verilerini filtrele
    const mainRegionData = data.filter(item => item.isSubRegion === 0);

    // Alt bölge verilerini filtrele
    const subRegionData = data.filter(item => item.isSubRegion === 1);

    // Tüm verileri tek bir array'de birleştir
    const allRows = [];

    // Ana bölgeleri ekle
    mainRegionData.forEach(item => {
      const regionTodaySale = item.regionTodaySale != null
        ? parseFloat(ConvertOIDValueToString({ type: 11 }, item.regionTodaySale)).toLocaleString('tr-TR')
        : '0';

      const regionYesterdaySale = item.regionYesterdaySale != null
        ? parseFloat(ConvertOIDValueToString({ type: 11 }, item.regionYesterdaySale)).toLocaleString('tr-TR')
        : '0';

      allRows.push({
        'Tür': 'Ana Bölge',
        'Ana Bölge Adı': item.regionName || '',
        'Alt Bölge Adı': '',
        'Bugünkü Satış (TL)': regionTodaySale,
        'Dünkü Satış (TL)': regionYesterdaySale,
        'Toplam Node': item.totalNodeQuantity || 0,
        'Online Node': item.onlineNodeQuantity || 0,
        'Offline Node': item.offilineNodeQuantity || 0,
        'Alarmlı Node': item.alarmedNodeQuantity || 0,
        'Uyarılı Node': item.warningNodeQuantity || 0,
      });
    });

    // Alt bölgeleri ekle
    subRegionData.forEach(item => {
      const subRegionTodaySale = item.subRegionTodaySale != null
        ? parseFloat(ConvertOIDValueToString({ type: 11 }, item.subRegionTodaySale)).toLocaleString('tr-TR')
        : '0';

      const subRegionYesterdaySale = item.subRegionYesterdaySale != null
        ? parseFloat(ConvertOIDValueToString({ type: 11 }, item.subRegionYesterdaySale)).toLocaleString('tr-TR')
        : '0';

      allRows.push({
        'Tür': 'Alt Bölge',
        'Ana Bölge Adı': item.regionName || '',
        'Alt Bölge Adı': item.subRegionName || '',
        'Bugünkü Satış (TL)': subRegionTodaySale,
        'Dünkü Satış (TL)': subRegionYesterdaySale,
        'Toplam Node': item.totalNodeQuantity || 0,
        'Online Node': item.onlineNodeQuantity || 0,
        'Offline Node': item.offilineNodeQuantity || 0,
        'Alarmlı Node': item.alarmedNodeQuantity || 0,
        'Uyarılı Node': item.warningNodeQuantity || 0,
      });
    });

    // Workbook oluştur
    const workbook = XLSX.utils.book_new();

    // Tek sheet oluştur
    const worksheet = XLSX.utils.json_to_sheet(allRows);

    // Sütun genişliklerini ayarla
    worksheet['!cols'] = [
      { wch: 12 }, // Tür
      { wch: 25 }, // Ana Bölge Adı
      { wch: 25 }, // Alt Bölge Adı
      { wch: 18 }, // Bugünkü Satış
      { wch: 18 }, // Dünkü Satış
      { wch: 15 }, // Toplam Node
      { wch: 15 }, // Online Node
      { wch: 15 }, // Offline Node
      { wch: 15 }, // Alarmlı Node
      { wch: 15 }, // Uyarılı Node
    ];

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Bölge Raporu');

    // Dosya adını tarih ile oluştur
    const now = new Date();
    const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const timeStr = `${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}`;
    const fileName = `Bolge_Raporu_${dateStr}_${timeStr}.xlsx`;

    // Excel dosyasını indir
    XLSX.writeFile(workbook, fileName);

    return { success: true, fileName };
  } catch (error) {
    console.error('Excel raporu oluşturulurken hata:', error);
    return { success: false, error: error.message };
  }
};
